import { api } from '../lib/api';

export interface SearchResult {
  objectID: string;
  type: string;
  title: string;
  summary: string;
  imageUrl: string;
  tags: string[];
  autoTags: string[];
  site: string;
  createdBy: string;
}

export async function searchItems(
  query: string,
  _filters?: { type?: string; tags?: string[]; site?: string },
): Promise<SearchResult[]> {
  if (!query.trim()) return [];

  const items = await api<any[]>(`/api/items/search?q=${encodeURIComponent(query)}`);

  return items.map((item) => ({
    objectID: item.id,
    type: item.type,
    title: item.title ?? '',
    summary: item.summary ?? '',
    imageUrl: item.imageUrl ?? '',
    tags: item.tags ?? [],
    autoTags: item.autoTags ?? [],
    site: item.site ?? '',
    createdBy: item.createdBy,
  }));
}
